import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';
const COLORES = ['#EC0000', '#FFFFFF', '#5B1FC4', '#FFD100'];
const DURACION_GIRO_MS = 5200;
const REFRESCO_MS = 15000;

type Entrada = { registro_id: number; nombre: string };
type Ganador = { id: number; nombre: string; premio: string; marca: string; entradas: number; anulado: boolean };
type Sorteo = { id: number; nombre: string; slug: string | null; url: string; premio: string; estado: string; registro: string; marca_bonificada: string };

const CSS = `
.ruleta { min-height: 100vh; background: radial-gradient(120% 90% at 100% 100%, #52107f 0%, #3A008C 55%); color: #fff;
  display: flex; flex-direction: column; align-items: center; padding: 24px 20px 40px; font-family: 'Work Sans', system-ui, sans-serif; }
.ruleta .logo { width: min(300px, 70vw); height: auto; filter: drop-shadow(0 2px 8px rgba(0,0,0,.45)); }
.ruleta .eyebrow { font-family: 'Barlow Condensed', sans-serif; font-weight: 700; font-size: 15px; letter-spacing: .06em; margin-top: 6px; }
.ruleta .nombre-sorteo { color: #C9B8F0; font-size: 14px; margin-top: 2px; }
.ruleta .premio { font-family: 'Barlow Condensed', sans-serif; font-weight: 800; font-size: clamp(26px, 4vw, 40px); margin: 6px 0 20px; text-align: center; line-height: 1.1; }
.ruleta .rueda-wrap { position: relative; width: min(86vw, 62vh, 560px); aspect-ratio: 1/1; }
.ruleta .puntero { position: absolute; top: -10px; left: 50%; transform: translateX(-50%); z-index: 5; width: 0; height: 0;
  border-left: 17px solid transparent; border-right: 17px solid transparent; border-top: 30px solid #FFD100; filter: drop-shadow(0 2px 3px rgba(0,0,0,.5)); }
.ruleta .borde { width: 100%; height: 100%; border-radius: 50%; border: 8px solid #431398; outline: 2px solid #6A3DBA; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,.5); }
.ruleta .giro { width: 100%; height: 100%; }
.ruleta canvas { width: 100%; height: 100%; display: block; }
.ruleta .centro { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 18%; aspect-ratio: 1/1; border-radius: 50%;
  background: #431398; border: 3px solid #EC0000; display: flex; align-items: center; justify-content: center; z-index: 4; }
.ruleta .centro img { width: 78%; height: auto; }
.ruleta .btn-girar { margin-top: 26px; padding: 16px 56px; background: #EC0000; color: #fff; border: none; border-radius: 8px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800; font-size: 24px; letter-spacing: .06em; cursor: pointer; box-shadow: 0 6px 20px rgba(236,0,0,.35); }
.ruleta .btn-girar:hover:not(:disabled) { background: #C40000; }
.ruleta .btn-girar:disabled { opacity: .5; cursor: default; }
.ruleta .info { color: #C9B8F0; font-size: 13px; margin-top: 12px; text-align: center; }
.ruleta .error { margin-top: 12px; background: #4A0A0A; border: 1px solid #EC0000; color: #FFD6D6; padding: 10px 14px; border-radius: 8px; font-size: 14px; max-width: 480px; text-align: center; }
.ruleta .controles { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; margin-top: 18px; }
.ruleta .controles button, .ruleta .controles a { background: transparent; border: 1px solid #6A3DBA; color: #C9B8F0; padding: 7px 14px;
  border-radius: 8px; font-size: 13px; cursor: pointer; text-decoration: none; }
.ruleta .controles button:hover, .ruleta .controles a:hover { color: #fff; border-color: #C9B8F0; }
.ruleta .editar-premio { display: flex; gap: 8px; margin-top: 10px; width: min(440px, 90vw); }
.ruleta .editar-premio input { flex: 1; padding: 9px 12px; background: #2A0068; border: 1px solid #6A3DBA; border-radius: 8px; color: #fff; font-size: 14px; }
.ruleta .ultimos { margin-top: 26px; text-align: center; }
.ruleta .ultimos .titulo { color: #C9B8F0; font-size: 12px; letter-spacing: .08em; margin-bottom: 8px; }
.ruleta .chip { display: inline-block; margin: 3px; padding: 5px 12px; border-radius: 999px; background: rgba(255,209,0,.12); border: 1px solid rgba(255,209,0,.4); color: #FFD100; font-size: 13px; }
.ruleta .chip.anulado { text-decoration: line-through; opacity: .5; }
.ruleta .qr-vivo { position: fixed; right: 18px; bottom: 18px; background: #fff; color: #2A0068; border-radius: 14px; padding: 10px 10px 8px;
  text-align: center; box-shadow: 0 8px 30px rgba(0,0,0,.4); z-index: 10; width: 168px; }
.ruleta .qr-vivo img { width: 148px; height: 148px; display: block; }
.ruleta .qr-vivo .t { font-family: 'Barlow Condensed', sans-serif; font-weight: 800; font-size: 17px; line-height: 1.1; }
.ruleta .qr-vivo .u { font-size: 10px; color: #6A3DBA; word-break: break-all; margin-top: 2px; }
@media (max-width: 900px) { .ruleta .qr-vivo { display: none; } }
.overlay { position: fixed; inset: 0; background: rgba(28,0,70,.97); display: flex; align-items: center; justify-content: center; z-index: 50; padding: 20px; }
.overlay .tarjeta { text-align: center; max-width: 640px; animation: aparecer .5s ease; color: #fff; }
@keyframes aparecer { from { transform: scale(.7); opacity: 0; } to { transform: scale(1); opacity: 1; } }
.overlay img { height: 170px; width: auto; margin-bottom: 10px; }
.overlay .felicidades { color: #FFD100; font-family: 'Barlow Condensed', sans-serif; font-weight: 800; font-size: 28px; letter-spacing: .05em; }
.overlay .nombre { font-family: 'Barlow Condensed', sans-serif; font-weight: 800; color: #FFD100; font-size: clamp(40px, 9vw, 84px); line-height: 1.05; margin: 10px 0; word-break: break-word; }
.overlay .detalle { color: #C9B8F0; font-size: 15px; }
.overlay .premio-ganado { font-size: 20px; margin: 10px 0 30px; }
.overlay .premio-ganado b { color: #FFD100; }
.overlay button { padding: 12px 34px; background: #431398; border: 1px solid #6A3DBA; color: #fff; border-radius: 8px; font-size: 16px; cursor: pointer; }
`;

function textoCorto(t: string, max: number) {
  return t.length > max ? t.slice(0, max - 1) + '…' : t;
}

function dibujarRueda(canvas: HTMLCanvasElement, entradas: Entrada[]) {
  const dpr = window.devicePixelRatio || 1;
  const tam = canvas.clientWidth;
  if (!tam) return;
  canvas.width = tam * dpr;
  canvas.height = tam * dpr;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  ctx.scale(dpr, dpr);
  const c = tam / 2;
  const n = entradas.length;
  ctx.clearRect(0, 0, tam, tam);
  if (n === 0) {
    ctx.fillStyle = '#2A0068';
    ctx.beginPath();
    ctx.arc(c, c, c, 0, Math.PI * 2);
    ctx.fill();
    return;
  }
  const seg = (Math.PI * 2) / n;
  const conTexto = n <= 150;
  const fuente = Math.max(9, Math.min(18, (tam * 0.5) / n));
  const maxLetras = Math.max(8, Math.floor((c * 0.75) / (fuente * 0.55)));
  for (let i = 0; i < n; i++) {
    const inicio = -Math.PI / 2 + i * seg;
    let color = COLORES[i % COLORES.length];
    if (i === n - 1 && n > 1 && color === COLORES[0]) color = COLORES[(i + 1) % COLORES.length];
    ctx.beginPath();
    ctx.moveTo(c, c);
    ctx.arc(c, c, c, inicio, inicio + seg);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
    if (n <= 300) {
      ctx.strokeStyle = 'rgba(0,0,0,.3)';
      ctx.lineWidth = 1;
      ctx.stroke();
    }
    if (conTexto) {
      ctx.save();
      ctx.translate(c, c);
      ctx.rotate(inicio + seg / 2);
      ctx.textAlign = 'right';
      const claro = color === '#FFD100' || color === '#FFFFFF';
      ctx.fillStyle = claro ? '#2A0068' : '#fff';
      ctx.font = `600 ${fuente}px 'Work Sans', system-ui, sans-serif`;
      ctx.fillText(textoCorto(entradas[i].nombre, maxLetras), c - 14, fuente / 3);
      ctx.restore();
    }
  }
}

export default function RifaPantalla() {
  const { id } = useParams();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const giroRef = useRef<HTMLDivElement>(null);
  const [sorteo, setSorteo] = useState<Sorteo | null>(null);
  const [entradas, setEntradas] = useState<Entrada[]>([]);
  const [personas, setPersonas] = useState(0);
  const [ultimos, setUltimos] = useState<Ganador[]>([]);
  const [premio, setPremio] = useState('');
  const [editandoPremio, setEditandoPremio] = useState(false);
  const [girando, setGirando] = useState(false);
  const [ganador, setGanador] = useState<Ganador | null>(null);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    document.title = 'Ruleta — TicoBaterías';
    if (!document.getElementById('fuente-barlow')) {
      const link = document.createElement('link');
      link.id = 'fuente-barlow';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800&family=Work+Sans:wght@400;600&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const cargar = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/rifa/sorteos/${id}/pantalla`, { headers });
      setSorteo(r.data.sorteo);
      setEntradas(r.data.entradas);
      setPersonas(r.data.personas);
      setUltimos(r.data.ultimos_ganadores);
      setPremio(p => (editandoPremio ? p : r.data.sorteo.premio));
      setError('');
    } catch (e: any) {
      setError(e?.response?.status === 404 ? 'Este sorteo no existe.' : 'No se pudo cargar la ruleta. Revisa la conexión.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, editandoPremio]);

  useEffect(() => { cargar(); }, [cargar]);

  // Mientras nadie gira, la lista se actualiza sola (para que entren los que se registran en vivo)
  useEffect(() => {
    if (girando || ganador) return;
    const t = setInterval(cargar, REFRESCO_MS);
    return () => clearInterval(t);
  }, [cargar, girando, ganador]);

  const redibujar = useCallback(() => {
    if (canvasRef.current) dibujarRueda(canvasRef.current, entradas);
  }, [entradas]);

  useEffect(() => {
    redibujar();
    window.addEventListener('resize', redibujar);
    return () => window.removeEventListener('resize', redibujar);
  }, [redibujar]);

  const girar = async () => {
    if (girando || !giroRef.current) return;
    setGirando(true);
    setError('');
    try {
      const r = await axios.post(`${API}/rifa/sorteos/${id}/girar`, { premio }, { headers });
      const lista: Entrada[] = r.data.entradas;
      const indice: number = r.data.indice;
      const elegido: Ganador = r.data.ganador;

      // Se dibuja exactamente la lista con la que el servidor sorteo
      setEntradas(lista);
      if (canvasRef.current) dibujarRueda(canvasRef.current, lista);

      const el = giroRef.current;
      const gradosSeg = 360 / lista.length;
      const desfase = (Math.random() - 0.5) * gradosSeg * 0.6; // no cae siempre en el centro exacto
      const destino = 6 * 360 + (360 - (indice + 0.5) * gradosSeg) + desfase;
      el.style.transition = 'none';
      el.style.transform = 'rotate(0deg)';
      void el.offsetHeight;
      el.style.transition = `transform ${DURACION_GIRO_MS}ms cubic-bezier(0.15, 0.65, 0.1, 1)`;
      el.style.transform = `rotate(${destino}deg)`;

      setTimeout(() => {
        setGanador(elegido);
        setSorteo(s => (s ? { ...s, premio: elegido.premio } : s));
      }, DURACION_GIRO_MS + 150);
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      setError(typeof d === 'string' ? d : d?.mensaje || 'No se pudo girar. Intenta de nuevo.');
      setGirando(false);
    }
  };

  const cerrarGanador = async () => {
    setGanador(null);
    setGirando(false);
    if (giroRef.current) {
      giroRef.current.style.transition = 'none';
      giroRef.current.style.transform = 'rotate(0deg)';
    }
    await cargar();
  };

  const pantallaCompleta = () => {
    if (document.fullscreenElement) document.exitFullscreen?.();
    else document.documentElement.requestFullscreen?.();
  };

  const finalizado = sorteo?.estado === 'finalizado';

  return (
    <div className="ruleta">
      <style>{CSS}</style>
      <img className="logo" src="/rifa-assets/ticobaterias-logo.webp" alt="TicoBaterías" />
      <div className="eyebrow">SORTEO · PURA <span style={{ color: '#EC0000' }}>ENERGÍA</span> ⚡</div>
      {sorteo && <div className="nombre-sorteo">{sorteo.nombre}</div>}
      <div className="premio">{sorteo?.premio || '🎁'}</div>

      <div className="rueda-wrap">
        <div className="puntero" />
        <div className="borde">
          <div className="giro" ref={giroRef}>
            <canvas ref={canvasRef} />
          </div>
        </div>
        <div className="centro"><img src="/rifa-assets/ticobaterias-mascota.webp" alt="" /></div>
      </div>

      <button className="btn-girar" onClick={girar} disabled={girando || entradas.length === 0 || finalizado}>
        {girando ? 'GIRANDO...' : 'GIRAR'}
      </button>

      {error && <div className="error">{error}</div>}
      {!error && entradas.length === 0 && sorteo && <div className="info">No quedan participantes en la ruleta.</div>}
      {finalizado && <div className="info">Este sorteo está finalizado. Cambia su estado en el panel para volver a girar.</div>}
      <div className="info">
        {personas} {personas === 1 ? 'persona' : 'personas'} · {entradas.length} {entradas.length === 1 ? 'entrada' : 'entradas'} en la ruleta
      </div>

      {editandoPremio && (
        <div className="editar-premio">
          <input value={premio} onChange={e => setPremio(e.target.value)} placeholder="Premio del próximo giro" maxLength={200} autoFocus />
          <button onClick={() => { setEditandoPremio(false); setSorteo(s => (s ? { ...s, premio } : s)); }}
            style={{ background: '#EC0000', border: 'none', color: '#fff', padding: '0 16px', borderRadius: 8, fontWeight: 700 }}>
            Listo
          </button>
        </div>
      )}

      <div className="controles">
        {!editandoPremio && <button onClick={() => setEditandoPremio(true)} disabled={girando}>🎁 Cambiar premio</button>}
        <button onClick={cargar} disabled={girando}>↻ Actualizar lista</button>
        <button onClick={pantallaCompleta}>⛶ Pantalla completa</button>
        <Link to="/rifa">← Panel</Link>
      </div>

      {ultimos.length > 0 && (
        <div className="ultimos">
          <div className="titulo">ÚLTIMOS GANADORES</div>
          {ultimos.map(g => (
            <span key={g.id} className={`chip ${g.anulado ? 'anulado' : ''}`}>🏆 {g.nombre} · {g.premio}</span>
          ))}
        </div>
      )}

      {sorteo?.slug && sorteo.registro === 'abierto' && !ganador && (
        <div className="qr-vivo">
          <div className="t">¡Escanea y participa!</div>
          <img src={`${API}/rifa/qr/${sorteo.slug}.svg`} alt="QR para registrarse" />
          <div className="u">{sorteo.url.replace('https://', '')}</div>
        </div>
      )}

      {ganador && (
        <div className="overlay">
          <div className="tarjeta">
            <img src="/rifa-assets/ticobaterias-mascota.webp" alt="TicoBaterías" />
            <div className="felicidades">¡FELICIDADES!</div>
            <div className="nombre">{ganador.nombre}</div>
            {ganador.entradas > 1 && <div className="detalle">⭐ Participaba con {ganador.marca} ×{ganador.entradas}</div>}
            <div className="premio-ganado">Ganó: <b>{ganador.premio || 'el premio'}</b></div>
            <button onClick={cerrarGanador}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
}
